
import Logistics from "@/store/modules/system/logistics/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins } from "@/lib";
@Component({})
export default class CreateLogistics extends Mixins(FormModalMixins) {
  model: Logistics = new Logistics();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Add", labelWidth: 150, okAction: "system/logistics/create" });
    this.model.isTrailer=true;
  }

  mounted() {
    // (this.$refs["form-modal"] as any).resetFields();
  }
}
